"use client"

import { reatomComponent } from "@reatom/react"
import { useAccountEmailAuth } from "../settings/use-account-email-auth"
import { useLinkedEmailPromptController } from "./linked-email-prompt-controller"
import { LinkedEmailPromptDialog } from "./linked-email-prompt-dialog"

export const LinkedEmailPrompt = reatomComponent(() => {
  const { userId, authenticated } = useAccountEmailAuth()
  if (!authenticated || !userId) return null
  return <AccountEmailPrompt key={userId} />
}, "LinkedEmailPrompt")

const AccountEmailPrompt = reatomComponent(() => {
  const { isOpen, pending, dismiss, submit, mode, error, actionLabel } =
    useLinkedEmailPromptController()
  return (
    <LinkedEmailPromptDialog
      open={isOpen}
      pending={pending}
      mode={mode}
      error={error}
      actionLabel={actionLabel}
      onAddEmail={submit}
      onDismiss={dismiss}
    />
  )
}, "AccountEmailPrompt")
